import { render, staticRenderFns } from "./form_add.vue?vue&type=template&id=9d0fdea6&scoped=true"
import script from "./form_add.vue?vue&type=script&lang=js"
export * from "./form_add.vue?vue&type=script&lang=js"
import style0 from "./form_add.vue?vue&type=style&index=0&id=9d0fdea6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0fdea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d0fdea6')) {
      api.createRecord('9d0fdea6', component.options)
    } else {
      api.reload('9d0fdea6', component.options)
    }
    module.hot.accept("./form_add.vue?vue&type=template&id=9d0fdea6&scoped=true", function () {
      api.rerender('9d0fdea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/task_manage/work_summary/form/components/form_add.vue"
export default component.exports